import { useContext } from 'react';
import { UserContext } from '@as_core/contexts/UserContext';
import { authCoreClient, ValidatedResponse } from '@utils/api/base';
import { processAxiosResponse } from '@utils/api/utils';
import useCognito from '@as_core/account/useCognito';
import { APP_CONFIG } from '@app_config/app';
import { HelpResourceT } from './utils/types';
import { AxiosRequestConfig } from 'axios';

// the api settings
export const HelpResources = {
  get: (token: string, config: AxiosRequestConfig) =>
    authCoreClient(token).get('/help_resources', config),
  get_url: (token: string, s3_ref: string) =>
    authCoreClient(token).get(`/files/get_url?s3_ref=${s3_ref}`),
};

const useHelpResources = () => {
  const { getToken } = useCognito();
  const { user } = useContext(UserContext);

  // create new user authorizations -- used by admin/maintenance
  const getHelpResources = async (
    params: {[key: string]: string}
  ): Promise<HelpResourceT[]> => {
    params = {system: APP_CONFIG.system, product: user.subApp, ...params};
    const config:AxiosRequestConfig = { params }
    const resp: ValidatedResponse<HelpResourceT[]> = await HelpResources.get(
      getToken(), config
    );
    return processAxiosResponse('HelpResources.search', resp);
  };

  // retrieve a url from AWS for the S3 location
  const getS3Url = async (
    s3_ref: string
  ): Promise<string> => {
    // console.log('searchHelpResources:', system, subApp, text);
    const resp: ValidatedResponse<string> = await HelpResources.get_url(getToken(), s3_ref)
    return processAxiosResponse('Files.getS3Url', resp);
  };

  return {
    getHelpResources,
    getS3Url,
  };
};

export default useHelpResources;
